import Layout from '@/components/feature/Layout';
import HeroSection from './components/HeroSection';
import PainPointsSection from './components/PainPointsSection';
import ServicesSection from './components/ServicesSection';
import ExpertiseSection from './components/ExpertiseSection';
import AboutSection from './components/AboutSection';
import TestimonialsSection from './components/TestimonialsSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <Layout>
      <HeroSection />
      <PainPointsSection />
      <ServicesSection />
      <ExpertiseSection />
      <AboutSection />
      <TestimonialsSection />
      <NewsletterSection />
    </Layout>
  );
}